export function processKycStatuses(kyc) {
  const showKyc = kyc?.kycrequired && !kyc?.kycpassed && kyc?.messages[0] === "KYC Required";
  const showKycPending = kyc?.kycrequired && !kyc?.kycpassed && kyc?.messages[0] === "KYC still pending";
  return { showKyc, showKycPending };
}
